import React from 'react';
import { connect } from 'react-redux';
import * as formTypes from 'constants/formTypes';
import i18n from 'util/i18n';
import { updateApplication } from '@redux/modules/application/actions';
import { rootSelectors } from '@redux/modules/selectors';
import { bindActionCreators } from 'redux';
import { Instructions } from '../../../views';
import { Modal } from '../../Modal';
import Branch from '../Branch';
import { logoutRequest } from '../../../redux/modules/authentication/actions';

export class Introduction extends React.Component {
  constructor(props) {
    super(props);
    this.updateBranch = this.updateBranch.bind(this);
  }

  componentDidMount() {
    // Focus on the "Yes" value after initial mounting
    if (window && window.document) {
      const el = window.document.querySelector('.introduction-modal .branch .yes input');
      if (el) {
        el.focus();
      }
    }
  }

  updateBranch(values) {
    if (values.value === 'No') {
      this.props.updateApplication('Settings', 'acceptedTerms', { value: '' });
      this.props.logoutRequest();
      return;
    }

    this.props.updateApplication('Settings', 'acceptedTerms', values);
  }

  render() {
    const accepted = this.props.acceptedTerms?.value === 'Yes' ?? false;

    let acceptancePara = i18n.m('introduction.acceptance.para');

    switch (this.props.formType) {
      case formTypes.PVQ_A:
      case formTypes.PVQ_A_B:
      case formTypes.PVQ_A_B_C:
      case formTypes.PVQ_A_B_D: {
        acceptancePara = i18n.m('introduction.acceptance.paraPvq');
        break;
      }
      case formTypes.SF86: {
        // currently uses default acceptancePara
        break;
      }
      case formTypes.SF852013:
      case formTypes.SF85: {
        acceptancePara = i18n.m('introduction.acceptance.para85');
        break;
      }
      case formTypes.SF85P: {
        acceptancePara = i18n.m('introduction.acceptance.para85p');
        break;
      }
      case formTypes.SF85PS: {
        acceptancePara = i18n.m('introduction.acceptance.para85ps');
        break;
      }
      default:
        break;
    }

    // This is gated behind isLoading to allow the Loading Modal to take
    // priority when it is on the screen.
    return (
      <Modal
        className="introduction-content"
        show={!accepted && this.props.isLoading === false}
        onDismiss={this.props.onDismiss}
      >
        <div>
          <div className="introduction-legal" tabIndex="0">
            <Instructions isModal />
          </div>
          <Branch
            disableSaveRequest
            label={i18n.t('introduction.acceptance.title')}
            labelSize="h2"
            name="acceptance_of_terms"
            {...this.props.acceptedTerms}
            yesAriaLabel={i18n.t('introduction.acceptance.aria.yes')}
            noAriaLabel={i18n.t('introduction.acceptance.aria.no')}
            optional
            className="introduction-acceptance no-margin-bottom"
            onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          >
            {acceptancePara}
          </Branch>
        </div>
      </Modal>
    );
  }
}

Introduction.defaultProps = {
  acceptedTerms: { value: '' },
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  formType: rootSelectors.application.getFormType(state),
  acceptedTerms: state.application.Settings.acceptedTerms,
  isLoading: rootSelectors.api.isLoading(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    logoutRequest,
    updateApplication,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);
